import PropTypes from 'prop-types'

import useCategory from '@shared/hooks/useCategory'

const CategoryMain = ({ category, seoData, currentSeriesData, rankingTabData }) => {
  const { getCategoryPages } = useCategory({ category, seoData, currentSeriesData, rankingTabData })
  return getCategoryPages()
}
CategoryMain.propTypes = {
  category: PropTypes.object,
  seoData: PropTypes.object
}

export default CategoryMain
